import queryString from 'query-string';
import KU_QUERY from '@/constants/common/searchParamKeys';
import {matchPath} from 'react-router-dom';

import routers, {ServerConfig} from '@/config/routers';
import {
    stringify,
    parse,
    addSearchParamNoRefresh,
    removeSearchParamNoRefresh,
    getUrlParams,
    getParamFromCustomUrl,
    addParamToCustomUrl,
    removeParamToCustomUrl,
} from '@/utils/kuQuery';

// TODO: 部分原有写法为兼容原有代码，因此保持export，待KU_QUERY完全迁移后可以清除
// 请使用'@/utils/kuQuery'下的crud方法
export {
    addSearchParamNoRefresh, removeSearchParamNoRefresh, getUrlParams,
    getParamFromCustomUrl, addParamToCustomUrl, removeParamToCustomUrl,
};
import {KNOWLEDGE_PATH_NAME} from '@/Constant';

function mergePathAndSearch(path: string, searchStr: string) {
    let search = searchStr;
    if (search.length > 0) {
        search = `?${search}`;
    }
    return `${path}${search}`;
}

export function getCurPathWithoutTicket(): string {
    const curPath = window.location.pathname;
    const curParams = parse(location.search);
    delete curParams.ticket;
    return mergePathAndSearch(curPath, stringify(curParams));
}

export function getRepoAvatarUrl(spaceGuid: string, groupGuid: string, repositoryGuid: string) {
    return `${ServerConfig.as}/spaces/${spaceGuid}/groups/${groupGuid}/repositories/${repositoryGuid}/resources/avatar`;
}

function getDepImgUrl(spaceGuid: string, groupGuid: string, type: 'avatar' | 'cover' = 'avatar') {
    if (!spaceGuid || !groupGuid) {
        return '';
    }
    return `${ServerConfig.as}/spaces/${spaceGuid}/groups/${groupGuid}/resources/${type}`;
}

export function getDepAvatarUrl(spaceGuid: string, groupGuid: string) {
    return getDepImgUrl(spaceGuid, groupGuid);
}

export function getDepCoverUrl(spaceGuid: string, groupGuid: string) {
    return getDepImgUrl(spaceGuid, groupGuid, 'cover');
}


export function getUrlInfo(url: string) {
    // eslint-disable-next-line @typescript-eslint/init-declarations
    let pathname;
    try {
        pathname = new URL(url);
    } catch {
        pathname = url;
    }
    const pathArr = `${pathname}`.split('/');
    if (pathArr[1] === 'knowledge') {
        return {
            spaceId: pathArr[2],
            groupId: pathArr[3],
            repoId: pathArr[4],
            pageId: pathArr[5] || '',
        };
    }
    return null;
}

export function replaceHttpsUrl() {
    return window.location.href.replace('https:', 'http:');
}

export function isInKuShare() {
    const query = getUrlParams();
    return query?.action?.includes('kushare') && query?.token;
}

export const getHeadingUuidByUrl = (url = document.URL) => {
    // 根据规则解析出当前的anchor uuid，默认使用hash方式
    const anchor = '#anchor-';
    const indexOfHash = url.indexOf(anchor);
    if (indexOfHash < 0) {
        return '';
    }
    const uuid = url.slice(indexOfHash + anchor.length);
    return uuid;
};

export const getBlockIdByUrl = (url = document.URL) => {
    const blockId = getParamFromCustomUrl(url, KU_QUERY.document.block_id) as string;
    return blockId || '';
};

export const getRightCommentIdByUrl = (url = document.URL) => {
    const id = getParamFromCustomUrl(url, KU_QUERY.document.rightCommentId) as string;
    return id || '';
};

// 解析文档url中的docId
export const getDocIdByUrl = (url: string) => {
    let pathname = '';
    try {
        pathname = new URL(url).pathname;
    } catch {
        pathname = url;
    }
    // 防止出现用户添加移动端文档地址到超链接的情况
    if (pathname.startsWith('/knowledge') || pathname.startsWith('/m/knowledge')) {
        const pathArr = `${pathname}`.split('/');
        return pathArr[pathArr.length - 1];
    }
    return '';
};

// 解析文档url中id
export const getDocInfoByUrl = (url: string) => {
    try {
        let pathname = new URL(url).pathname;
        pathname = pathname.replace('/m/', '/');

        const routerPublicPath = process.env.REACT_APP_ROUTER_PUBLIC_PATH || '';
        const baseNum = routerPublicPath ? 2 : 1;

        const pathArr = `${pathname}`.split('/');
        if (pathArr[baseNum] === 'knowledge') {
            return {
                spaceGuid: pathArr[baseNum + 1],
                groupGuid: pathArr[baseNum + 2],
                repositoryGuid: pathArr[baseNum + 3],
                docGuid: pathArr[baseNum + 4] || '',
            };
        }
        return null;
    } catch (err) {
        console.error(err);
    }
};

(window as any).matchPath = matchPath;

// 无刷新打开下载url
export const downloadUrl = (url: string) => {
    const eleLink = document.createElement('a');
    eleLink.style.display = 'none';
    eleLink.href = url;
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
};

export function isDocShortUrl(url: string) {
    if (!url) {
        return false;
    }
    // const shortReg = new RegExp('/d/.+'); // 本地测试用
    const shortReg = new RegExp(`${window.location.hostname}.*/d/.+`);
    return shortReg.test(url);
}

export function isDocUrl(url: string) {
    if (!url) {
        return false;
    }
    // const reg = new RegExp('/knowledge/.+/.+/.+/.+'); // 本地测试用
    const reg = new RegExp(`${window.location.hostname}.*/knowledge/.+/.+/.+/.+`);
    return reg.test(url);
}

export function getKnowledgePageRouteMatchInfo() {
    const isKnowledgePage = location.pathname.includes('/knowledge');
    const routerPublicPath = process.env.REACT_APP_ROUTER_PUBLIC_PATH || '';
    const baseNum = routerPublicPath ? 2 : 1;
    const pathData = location.pathname.split('/');
    const spaceGuid = pathData[baseNum + 1];
    const groupGuid = pathData[baseNum + 2];
    const repositoryGuid = pathData[baseNum + 3];
    const docGuid = pathData[baseNum + 4];
    const isDocPage = isKnowledgePage && !!docGuid
            && (!Object.values(KNOWLEDGE_PATH_NAME).includes(docGuid));
    return {isDocPage, isKnowledgePage, docGuid, spaceGuid, groupGuid, repositoryGuid, pathData};
}

/**
 * url匹配queryString和hash正则表达式
 * 第一个捕获组：不包含queryString和hash的前缀url
 * 第二个捕获组：queryString，不包含问号?
 * 第三个捕获组：hash，包含井号#
 */
export const URL_QUERY_HASH_REG = /^([^?]+)(?:\?([^#]+))?(#.+)?/;
